export const ACTION_NOTIFICATION_HELP_SUPPORT = {
  Help: 'Help',
};
